// not exported, and should not be used directly.
const baseIcons = {
  SquareTerminal: 'SquareTerminal',
  Reply: 'Reply',
  Sparkles: 'Sparkles',
  WandSparkles: 'WandSparkles',
  Layers: 'Layers',
  Clipboard: 'Clipboard',
  Truck: 'Truck',
  Building2: 'Building2',
  Handshake: 'Handshake',
  Eraser: 'Eraser',
  Hash: 'Hash',
  Banknote: 'Banknote',
  User: 'User',
  MessageSquare: 'MessageSquare',
  File: 'File',
  Table: 'Table',
  Ban: 'Ban',
  Send: 'Send',
  Archive: 'Archive',
  ArchiveX: 'ArchiveX',
  CheckCheck: 'CheckCheck',
  Calendar: 'Calendar',
  OctagonAlert: 'OctagonAlert',
  Account: 'CircleUser',
  Headset: 'Headset',
  Agency: 'Home',
  Bell: 'Bell',
  Building: 'Building',
  Check: 'Check',
  Clients: 'Users',
  Close: 'X',
  CodeRegistries: 'LibraryBig',
  Contact: 'Contact',
  Copy: 'Copy',
  Dashboard: 'LayoutDashboard',
  Database: 'Database',
  Delete: 'Trash',
  DatabaseZap: 'DatabaseZap',
  DotsVertical: 'EllipsisVertical',
  DotsHorizontal: 'Ellipsis',
  Menu: 'Menu',
  FileDocumentOutline: 'FileText',
  History: 'History',
  Home: 'Home',
  Organization: 'Building',
  LogOut: 'LogOut',
  Minus: 'Minus',
  MoveVertical: 'MoveVertical',
  OrgAndUsers: 'BookUser',
  Pencil: 'Pencil',
  Radical: 'Radical',
  Search: 'Search',
  Settings: 'Settings',
  SunMoon: 'SunMoon',
  Sun: 'Sun',
  Moon: 'Moon',
  SlidersHorizontal: 'SlidersHorizontal',
  UserCog: 'UserCog',
  Ship: 'Ship',
  Presentation: 'Presentation',
  CircleHelp: 'CircleHelp',
  HeartCrack: 'HeartCrack',
  Grip: 'Grip',
  LinkedIn: 'Linkedin',
  Mail: 'Mail',
  ChevronDown: 'ChevronDown',
  ChevronLeft: 'ChevronLeft',
  ChevronRight: 'ChevronRight',
  ChevronUp: 'ChevronUp',
  ChevronsUpDown: 'ChevronsUpDown',
  ChevronsDownUp: 'ChevronsDownUp',
  Network: 'Network',
  Group: 'Group',
  BicepsFlexed: 'BicepsFlexed',
  List: 'List',
  Restore: 'ArchiveRestore',
  RotateCcw: 'RotateCcw',
  Refresh: 'RefreshCw',
  Undo2: 'Undo2',
  Plus: 'Plus',
  ListFilter: 'ListFilter',
  EllipsisVertical: 'EllipsisVertical',
  Ellipsis: 'Ellipsis',
  LoaderCircle: 'LoaderCircle',
  MapPin: 'MapPin',
  Clock: 'Clock',
  MapPinned: 'MapPinned',
  LifeBuoy: 'LifeBuoy',
  Play: 'Play',
  Pause: 'Pause',
  PanelLeft: 'PanelLeft',
  Edit: 'Edit',
  TriangleAlert: 'TriangleAlert',
  Link: 'Link',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  RadioTower: 'RadioTower',
  Earth: 'Earth',
  Lock: 'Lock',
  Coffee: 'Coffee',
  Component: 'Component',
  Phone: 'Phone',
  CircleMinus: 'CircleMinus',
  CircleDot: 'CircleDot',
  CirclePlus: 'CirclePlus',
  CircleEllipsis: 'CircleEllipsis',
  Loader: 'Loader',
  PlugZap: 'PlugZap',
  Unplug: 'Unplug',
  UserRoundCog: 'UserRoundCog',
  Trash: 'Trash',
  ChartLine: 'ChartLine',
  ArrowRightFromLine: 'ArrowRightFromLine',
  ArrowDownToLine: 'ArrowDownToLine',
  ReceiptText: 'ReceiptText',
  MessageSquareShare: 'MessageSquareShare',
  Users: 'Users',
  Inbox: 'Inbox',
  ExternalLink: 'ExternalLink',
  MoreHorizontal: 'MoreHorizontal',
  MoreVertical: 'MoreVertical',
  ArrowUpDown: 'ArrowUpDown',
  MoveUp: 'MoveUp',
  MoveDown: 'MoveDown',
  EyeOff: 'EyeOff',
  Settings2: 'Settings2',
  ChevronsLeft: 'ChevronsLeft',
  ChevronsRight: 'ChevronsRight',
  ChevronsUp: 'ChevronsUp',
  ChevronsDown: 'ChevronsDown',
  AtSign: 'AtSign',
  KeyRound: 'KeyRound',
  Info: 'Info',
  Upload: 'Upload',
  Crown: 'Crown',
  MessageCircleQuestion: 'MessageCircleQuestion',
  AppWindow: 'AppWindow',
  PanelRight: 'PanelRight',
  PanelsTopLeft: 'PanelsTopLeft',
  Camera: 'Camera',
  CalendarClock: 'CalendarClock',
  CalendarCog: 'CalendarCog',
  Globe: 'Globe',
  MonitorCog: 'MonitorCog',
  CalendarRange: 'CalendarRange',
  Calendar1: 'Calendar1',
  Calculator: 'Calculator',
  Flag: 'Flag',
  FlagOff: 'FlagOff',
  FlagTriangleLeft: 'FlagTriangleLeft',
  FlagTriangleRight: 'FlagTriangleRight',
  Download: 'Download',
  Json: 'Braces',
  FileSpreadsheet: 'FileSpreadsheet',
  FileJson: 'FileJson',
  Sheet: 'Sheet',
  ListTodo: 'ListTodo',
  CircleQuestionMark: 'CircleQuestionMark',
  DollarSign: 'DollarSign',
  LockOpen: 'LockOpen',
  Eye: 'Eye',
  PencilOff: 'PencilOff',
  ArrowBigUp: 'ArrowBigUp',
  Activity: 'Activity',
  Heart: 'Heart',
  Bookmark: 'Bookmark',
  BookmarkMinus: 'BookmarkMinus',
  BookmarkPlus: 'BookmarkPlus',
  Smartphone: 'Smartphone',
  BriefcaseBusiness: 'BriefcaseBusiness'
} as const

/** A collection of icons for actions which are commonly used. */
const actions = {
  /** Typically used by reactivate-actions */
  reactivate: baseIcons.Restore,
  /** Typically used by activate-actions */
  activate: baseIcons.Restore,
  /** Typically used by deactivate-actions */
  deactivate: baseIcons.HeartCrack,
  /** Typically used by edit-actions */
  edit: baseIcons.Pencil,
  /** Typically used by add-actions */
  add: baseIcons.Plus,
  /** Typically used by delete-actions */
  delete: baseIcons.Trash,
  /** Typically used by show-details-actions */
  showDetails: baseIcons.Eye
} as const

/** A collection of icons for the view-button. */
const views = {
  /** Typically used by table-actions  */
  table: baseIcons.Table,
  /** Typically used by table-actions  */
  deactivated: actions.deactivate,
  list: baseIcons.List
} as const

const tenantUser = {
  base: {
    tenantUser: baseIcons.Account,
    tenantAdmin: baseIcons.Crown,
    inactive: baseIcons.Ban
  },
  actions: {
    activateUser: baseIcons.Restore,
    deactivateUser: baseIcons.HeartCrack,
    grantTenantAdminPrivileges: baseIcons.Crown,
    revokeTenantAdminPrivileges: baseIcons.Crown,
    scheduleUserActivation: baseIcons.CalendarClock,
    scheduleUserDeactivation: baseIcons.CalendarClock,
    cancelActivationSchedule: baseIcons.CalendarClock,
    cancelDeactivationSchedule: baseIcons.Trash,
    changeProfileImage: baseIcons.Camera,
    changeName: baseIcons.Pencil,
    changeEmail: baseIcons.Mail,
    changePhone: baseIcons.Phone,
    changeTitle: baseIcons.Pencil
  },
  menuIcons: {
    general: baseIcons.Home,
    databaseAccess: baseIcons.Database,
    accessRoles: baseIcons.KeyRound,
    dangerZone: baseIcons.TriangleAlert
  }
} as const

const company = {
  base: {
    /** The icon representing a company. */
    company: baseIcons.Network,
    user: baseIcons.Account,
    tenantUser: baseIcons.Account
  },
  actions: {
    add: actions.add,
    edit: actions.edit,
    activate: actions.activate,
    deactivate: actions.deactivate,
    scheduleUserActivation: baseIcons.CalendarClock,
    scheduleUserDeactivation: baseIcons.CalendarClock
  },
  views: {
    table: views.table,
    deactivated: views.deactivated
  }
} as const

const agency = {
  base: {
    agencyStructure: baseIcons.Network,
    agency: baseIcons.Network,
    agencyGroup: baseIcons.Group
  },
  menuIcons: {
    general: baseIcons.Home,
    users: baseIcons.Users,
    userTeams: baseIcons.BicepsFlexed,
    whiteboards: baseIcons.Presentation,
    dangerZone: baseIcons.TriangleAlert
  },
  actions: {
    /** The icon used by add-group action */
    addGroup: baseIcons.Group,
    /** The icon used by add-agency action */
    addAgency: baseIcons.Network,
    /** The icon used by change-contact-info action */
    changeContactInfo: baseIcons.Contact,
    /** The icon used by link-to-other-company action */
    linkToOtherCompany: company.base.company,
    /** The icon used by deactivate action */
    deactivateAgency: actions.deactivate,
    /** The icon used by restore agency action */
    reactivateAgency: actions.reactivate,
    /** The icon used by change-naming action */
    changeNaming: actions.edit,
    /** The icon used by move-agency or move-group action */
    moveAgencyOrGroup: baseIcons.MoveVertical
  }
} as const

/** A collection of icons for buttons which are commonly used. */
const buttons = {
  /** Typically used by a button where the user can select different views/filters. */
  view: baseIcons.ListFilter
} as const

const common = {
  Sparkles: baseIcons.Sparkles,
  WandSparkles: baseIcons.WandSparkles,
  EyeOff: baseIcons.EyeOff,
  Eye: baseIcons.Eye,
  Invoice: baseIcons.ReceiptText,
  Globe: baseIcons.Globe,
  CircleQuestionMark: baseIcons.CircleQuestionMark,
  Link: baseIcons.Link,
  ArrowRight: baseIcons.ArrowRight,
  Copy: baseIcons.Copy,
  Phone: baseIcons.Phone,
  Mail: baseIcons.Mail,
  Pencil: baseIcons.Pencil,
  Info: baseIcons.Info,
  KeyRound: baseIcons.KeyRound,
  AtSign: baseIcons.AtSign,
  Calendar: baseIcons.Calendar,
  CircleUserRound: 'CircleUserRound',
  Ban: 'Ban',
  CalendarClock: 'CalendarClock',
  Database: baseIcons.Database,
  ChevronsLeft: baseIcons.ChevronsLeft,
  ChevronsRight: baseIcons.ChevronsRight,
  ChevronLeft: baseIcons.ChevronLeft,
  ChevronRight: baseIcons.ChevronRight,
  ChevronUp: baseIcons.ChevronUp,
  ChevronDown: baseIcons.ChevronDown,
  ChevronUpDown: baseIcons.ChevronsUpDown,
  ChevronDownUp: baseIcons.ChevronsDownUp,
  ChevronsUp: baseIcons.ChevronsUp,
  ChevronsDown: baseIcons.ChevronsDown,
  Settings2: baseIcons.Settings2,
  MoveUp: baseIcons.MoveUp,
  MoveDown: baseIcons.MoveDown,
  ArrowUpDown: baseIcons.ArrowUpDown,
  ArrowDownToLine: baseIcons.ArrowDownToLine,
  MoreHorizontal: baseIcons.MoreHorizontal,
  MoreVertical: baseIcons.MoreVertical,
  ExternalLink: baseIcons.ExternalLink,
  ArrowLeft: baseIcons.ArrowLeft,
  archive: baseIcons.Archive,
  filter: baseIcons.ListFilter,
  dotsVertical: baseIcons.EllipsisVertical,
  dotsHorizontal: baseIcons.Ellipsis,
  collapsed: baseIcons.ChevronsUpDown,
  expanded: baseIcons.ChevronsDownUp,
  chevronUp: baseIcons.ChevronUp,
  chevronDown: baseIcons.ChevronDown,
  chevronLeft: baseIcons.ChevronLeft,
  chevronRight: baseIcons.ChevronRight,
  close: baseIcons.Close,
  check: baseIcons.Check,
  loader: baseIcons.LoaderCircle,
  mapPin: baseIcons.MapPin,
  MapPinned: baseIcons.MapPinned,
  error: baseIcons.OctagonAlert,
  lifeBouy: baseIcons.LifeBuoy,
  play: baseIcons.Play,
  history: baseIcons.History,
  restore: baseIcons.Restore,
  disconnect: baseIcons.Unplug,
  delete: baseIcons.Trash,
  refresh: baseIcons.Refresh,
  connect: baseIcons.PlugZap,
  link: baseIcons.Link,
  search: baseIcons.Search,
  copy: baseIcons.Copy,
  phone: baseIcons.Phone,
  mail: baseIcons.Mail,
  circleDot: baseIcons.CircleDot,
  circlePlus: baseIcons.CirclePlus,
  circleMinus: baseIcons.CircleMinus,
  panelLeft: baseIcons.PanelLeft,
  help: baseIcons.CircleHelp,
  upload: baseIcons.Upload,
  Earth: baseIcons.Earth,
  Download: baseIcons.Download,
  Json: baseIcons.Json,
  FileSpreadsheet: baseIcons.FileSpreadsheet,
  FileJson: baseIcons.FileJson,
  Sheet: baseIcons.Sheet,
  Table: baseIcons.Table,
  ListTodo: baseIcons.ListTodo
} as const

const mainNavigation = {
  home: baseIcons.Home,
  dashboard: baseIcons.ChartLine,
  portcalls: baseIcons.Inbox,
  clients: baseIcons.BriefcaseBusiness,
  vessels: baseIcons.Ship,
  administration: baseIcons.Settings
} as const

const menuIcons = {
  generalDetails: baseIcons.Home,
  dangerZone: baseIcons.TriangleAlert,
  Grip: baseIcons.Grip,
  ArrowLeft: baseIcons.ArrowLeft,
  home: mainNavigation.home,
  dashboard: mainNavigation.dashboard,
  Minus: baseIcons.Minus,
  ChevronLeft: baseIcons.ChevronLeft,
  ChevronRight: baseIcons.ChevronRight,
  ChevronDown: baseIcons.ChevronDown,
  ChevronUp: baseIcons.ChevronUp,
  Debug: baseIcons.Radical,
  AdminMenu: baseIcons.Settings,
  ApplicationTheme: baseIcons.SunMoon,
  ClientsMenu: baseIcons.Clients,
  CodeRegistriesMenu: baseIcons.CodeRegistries,
  DocumentAndEmail: baseIcons.FileDocumentOutline,
  Menu: baseIcons.Menu,
  Expand: baseIcons.ArrowRightFromLine,
  LastUsedClients: baseIcons.History,
  LastUsedPortcalls: baseIcons.History,
  OrgAndUserMenu: baseIcons.OrgAndUsers,
  Organization: baseIcons.Organization,
  SearchMenu: baseIcons.Search,
  SettingsMenu: baseIcons.SlidersHorizontal,
  Users: baseIcons.Account,
  VesselsMenu: baseIcons.Ship,
  WhiteboardMenu: baseIcons.Presentation,
  Invoicing: baseIcons.ReceiptText,
  Proforma: baseIcons.MessageSquareShare,
  Companies: baseIcons.Building,
  AgencyStructure: baseIcons.Network
} as const

const userMenuIcons = {
  Account: baseIcons.Account, // safe
  ArrowDownToLine: baseIcons.ArrowDownToLine, // safe
  Database: baseIcons.Database, // safe
  LogOut: baseIcons.LogOut, // safe
  Theme: baseIcons.SunMoon, // safe
  Support: baseIcons.CircleHelp,
  RefreshCcw: baseIcons.Refresh
} as const

const themeIcons = {
  light: baseIcons.Sun,
  dark: baseIcons.Moon,
  auto: baseIcons.SunMoon
} as const

const notificationIcons = {
  appBar: baseIcons.Bell
} as const

const adminIcons = {
  CodeRegistriesMenu: baseIcons.CodeRegistries,
  DocumentAndEmail: baseIcons.FileDocumentOutline,
  AccessControl: baseIcons.KeyRound,
  Organization: baseIcons.Network,
  Users: baseIcons.Users,
  SettingsMenu: baseIcons.SlidersHorizontal,
  CurrencyCodes: baseIcons.DollarSign,
  ExchangeRates: baseIcons.CircleQuestionMark,
  AgencySettings: baseIcons.Building,
  GlobalSettings: baseIcons.Settings,
  Monetary: baseIcons.Banknote,
  settings: {
    invoicing: baseIcons.ReceiptText
  }
} as const

const settings = {
  invoicing: baseIcons.ReceiptText
} as const

const developerPageIcons = {
  httpClient: baseIcons.Earth,
  signalR: baseIcons.RadioTower,
  accessControl: baseIcons.Lock,
  components: baseIcons.Component,
  typesGeneration: baseIcons.Coffee
} as const
const support = {
  support: baseIcons.Headset,
  tabs: {
    contactSupport: baseIcons.Phone,
    supportSessions: baseIcons.User,
    supportHistory: baseIcons.History
  },
  actions: {
    grantSupportAccess: actions.add,
    startSupportSession: baseIcons.Play,
    endSupportSession: actions.deactivate,
    moreDetails: baseIcons.Info
  }
} as const

const accessControl = {
  groups: {
    organization: baseIcons.Building,
    support: baseIcons.MessageCircleQuestion,
    stakeholders: baseIcons.Users,
    monetary: baseIcons.Banknote,
    ai: baseIcons.Sparkles
  },
  base: {
    accessControl: baseIcons.KeyRound
  },
  actions: {
    add: actions.add,
    changeName: actions.edit,
    assignRole: actions.add,
    unassignRole: baseIcons.Minus,
    delete: baseIcons.Trash
  },
  tabs: {
    general: baseIcons.Home,
    users: baseIcons.Users,
    permissions: baseIcons.KeyRound,
    dangerZone: baseIcons.TriangleAlert
  }
} as const

const profileSettings = {
  uploadPhoto: baseIcons.Camera,
  base: baseIcons.UserCog,
  applicationPreferences: {
    /** The icon representing the application preferences. */
    groupIcon: baseIcons.MonitorCog,
    /** The icon representing the modal type. */
    modalType: {
      base: baseIcons.PanelsTopLeft,
      drawer: baseIcons.PanelRight,
      dialog: baseIcons.AppWindow
    },
    /** The icon representing the theme. */
    theme: {
      base: baseIcons.SunMoon,
      light: baseIcons.Sun,
      dark: baseIcons.Moon,
      auto: baseIcons.SunMoon
    }
  },
  localization: {
    /** The icon representing the localization. */
    groupIcon: baseIcons.Globe,
    /** The icon representing the date format. */
    dateFormat: {
      base: baseIcons.CalendarCog
    },
    /** The icon representing the week number format. */
    weekNumberFormat: {
      base: baseIcons.CalendarRange
    },
    /** The icon representing the first day of the week. */
    firstDayOfWeek: {
      base: baseIcons.Calendar1
    },
    /** The icon representing the number format. */
    numberFormat: {
      base: baseIcons.Calculator
    }
  },
  calendarPreferences: {
    /** The icon representing the calendar preferences. */
    groupIcon: baseIcons.CalendarClock,
    /** The icon representing the timezone. */
    timezone: {
      base: baseIcons.Earth
    }
  },
  featureFlags: {
    /** The icon representing the feature flags. */
    groupIcon: baseIcons.Flag,
    item: baseIcons.FlagTriangleRight
  }
} as const

const stakeholders = {
  base: baseIcons.Building,
  // Must be called client for use with stakeholderType 'client'
  client: {
    base: baseIcons.BriefcaseBusiness,
    menuIcons: {
      general: baseIcons.Home,
      invoicing: common.Invoice,
      followUps: baseIcons.History,
      contacts: baseIcons.Contact,
      documents: baseIcons.File,
      alerts: baseIcons.Bell,
      history: baseIcons.History,
      dangerZone: baseIcons.TriangleAlert
    }
  },
  // Must be called vendor for use with stakeholderType 'vendor'
  vendor: {
    base: baseIcons.Truck,
    menuIcons: {
      general: baseIcons.Home,
      invoicing: common.Invoice,
      followUps: baseIcons.History,
      contacts: baseIcons.Contact,
      documents: baseIcons.File,
      alerts: baseIcons.Bell,
      history: baseIcons.History,
      dangerZone: baseIcons.TriangleAlert
    }
  },

  actions: {
    editGeneral: baseIcons.Pencil,
    changePostAddress: baseIcons.Pencil,
    changeVisitAddress: baseIcons.Pencil,
    changeInvoiceAddress: baseIcons.Pencil,
    changeInternalIdentificationNumbers: baseIcons.Pencil,
    changeOfficialBusinessNumbers: baseIcons.Pencil
  },
  // Must be called other for use with stakeholderType 'other'
  other: {
    base: baseIcons.Building,
    menuIcons: {
      general: baseIcons.Home,
      followUps: baseIcons.History,
      contacts: baseIcons.Contact,
      documents: baseIcons.File,
      alerts: baseIcons.Bell,
      history: baseIcons.History,
      dangerZone: baseIcons.TriangleAlert
    }
  },
  contacts: {
    base: baseIcons.Contact,
    contactPerson: baseIcons.User,
    contactPoint: baseIcons.Building
  }
} as const

const mail = {
  Inbox: baseIcons.Inbox,
  Drafts: baseIcons.File,
  Sent: baseIcons.Send,
  Junk: baseIcons.ArchiveX,
  Trash: baseIcons.Trash,
  Archive: baseIcons.Archive
} as const

const appState = {
  locked: baseIcons.Lock,
  unlocked: baseIcons.LockOpen
} as const
export const icons = {
  common,
  menuIcons,
  adminIcons,
  notificationIcons,
  userMenuIcons,
  agency,
  actions,
  views,
  company,
  support,
  buttons,
  mainNavigation,
  dev: developerPageIcons,
  tenantUser,
  accessControl,
  themeIcons,
  profileSettings,
  stakeholders,
  mail,
  appState,
  settings
} as const

type Icons = typeof icons

type commonIcon = Icons['common'][keyof typeof icons.common]

type menuIcon = Icons['menuIcons'][keyof typeof icons.menuIcons]

type adminIcon = Icons['adminIcons'][keyof typeof icons.adminIcons]

type notificationIcon =
  Icons['notificationIcons'][keyof typeof icons.notificationIcons]

type userMenuIcon = Icons['userMenuIcons'][keyof typeof icons.userMenuIcons]

type agencyIcons =
  | Icons['agency'][keyof typeof icons.agency]
  | Icons['agency']['actions'][keyof typeof icons.agency.actions]
  | Icons['agency']['base'][keyof typeof icons.agency.base]

type actionsIcons = Icons['actions'][keyof typeof icons.actions]

type viewsIcons = Icons['views'][keyof typeof icons.views]

type tenantUserIcons = Icons['tenantUser'][keyof typeof icons.tenantUser]

type companyIcons = Icons['company'][keyof typeof icons.company]

type supportIcons = Icons['support'][keyof typeof icons.support]

type accessControlIcons =
  Icons['accessControl'][keyof typeof icons.accessControl]

type buttonsIcons = Icons['buttons'][keyof typeof icons.buttons]

type devIcons = Icons['dev'][keyof typeof icons.dev]

type mainNavigationIcons =
  Icons['mainNavigation'][keyof typeof icons.mainNavigation]

type themeIcons = Icons['themeIcons'][keyof typeof icons.themeIcons]

type userProfileIcons =
  Icons['profileSettings'][keyof typeof icons.profileSettings]

type stakeholdersIcons = Icons['stakeholders'][keyof typeof icons.stakeholders]

type mailIcons = Icons['mail'][keyof typeof icons.mail]

type appStateIcons = Icons['appState'][keyof typeof icons.appState]

type settingsIcons = Icons['settings'][keyof typeof icons.settings]

type BaseIcons = keyof typeof baseIcons

export type IconValues =
  | BaseIcons
  | commonIcon
  | menuIcon
  | notificationIcon
  | adminIcon
  | userMenuIcon
  | agencyIcons
  | actionsIcons
  | viewsIcons
  | companyIcons
  | supportIcons
  | buttonsIcons
  | devIcons
  | mainNavigationIcons
  | tenantUserIcons
  | accessControlIcons
  | themeIcons
  | userProfileIcons
  | stakeholdersIcons
  | mailIcons
  | appStateIcons
  | settingsIcons
